/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __awaiter, __extends, __generator } from "tslib";
import * as runtime from '../runtime';
import { LocationListGeoEntryFromJSON, LocationOptionsResponseFromJSON, LocationRequestToJSON, LocationResponseFromJSON, LocationSearchRequestToJSON, PagedResponseOfLocationListEntryFromJSON, } from '../models';
/**
 *
 */
var LocationRestControllerApi = /** @class */ (function (_super) {
    __extends(LocationRestControllerApi, _super);
    function LocationRestControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new location  \'Permission#CREATE_LOCATION\' is required to access to this endpoint
     * Create a new location  \'Permission#CREATE_LOCATION\' is required to access to this endpoint
     */
    LocationRestControllerApi.prototype.createLocationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.locationRequest === null || requestParameters.locationRequest === undefined) {
                            throw new runtime.RequiredError('locationRequest', 'Required parameter requestParameters.locationRequest was null or undefined when calling createLocation.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/locations",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: LocationRequestToJSON(requestParameters.locationRequest)
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return LocationResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a new location  \'Permission#CREATE_LOCATION\' is required to access to this endpoint
     * Create a new location  \'Permission#CREATE_LOCATION\' is required to access to this endpoint
     */
    LocationRestControllerApi.prototype.createLocation = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createLocationRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete location  \'Permission#DELETE_LOCATION\' is required to access to this endpoint
     * Delete location  \'Permission#DELETE_LOCATION\' is required to access to this endpoint
     */
    LocationRestControllerApi.prototype.deleteLocationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
                            throw new runtime.RequiredError('locationId', 'Required parameter requestParameters.locationId was null or undefined when calling deleteLocation.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/locations/{locationId}".replace("{".concat("locationId", "}"), encodeURIComponent(String(requestParameters.locationId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete location  \'Permission#DELETE_LOCATION\' is required to access to this endpoint
     * Delete location  \'Permission#DELETE_LOCATION\' is required to access to this endpoint
     */
    LocationRestControllerApi.prototype.deleteLocation = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteLocationRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get location details  \'Permission#READ_LOCATION\' is required to access to this endpoint
     * Get location details  \'Permission#READ_LOCATION\' is required to access to this endpoint
     */
    LocationRestControllerApi.prototype.getLocationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
                            throw new runtime.RequiredError('locationId', 'Required parameter requestParameters.locationId was null or undefined when calling getLocation.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/locations/{locationId}".replace("{".concat("locationId", "}"), encodeURIComponent(String(requestParameters.locationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return LocationResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get location details  \'Permission#READ_LOCATION\' is required to access to this endpoint
     * Get location details  \'Permission#READ_LOCATION\' is required to access to this endpoint
     */
    LocationRestControllerApi.prototype.getLocation = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLocationRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get location options <p> Only authenticated users can access to this endpoint
     * Get location options <p> Only authenticated users can access to this endpoint
     */
    LocationRestControllerApi.prototype.getLocationOptionsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/locations/options",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return LocationOptionsResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get location options <p> Only authenticated users can access to this endpoint
     * Get location options <p> Only authenticated users can access to this endpoint
     */
    LocationRestControllerApi.prototype.getLocationOptions = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLocationOptionsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List geo locations  \'Permission#READ_LOCATION\' is required to access to this endpoint
     * List geo locations  \'Permission#READ_LOCATION\' is required to access to this endpoint
     */
    LocationRestControllerApi.prototype.listGeoLocationsOfAllLocationsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        if (requestParameters.network !== undefined) {
                            queryParameters['network'] = requestParameters.network;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/locations/geo",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(LocationListGeoEntryFromJSON); })];
                }
            });
        });
    };
    /**
     * List geo locations  \'Permission#READ_LOCATION\' is required to access to this endpoint
     * List geo locations  \'Permission#READ_LOCATION\' is required to access to this endpoint
     */
    LocationRestControllerApi.prototype.listGeoLocationsOfAllLocations = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listGeoLocationsOfAllLocationsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List locations using pagination  \'Permission#READ_LOCATION\' is required to access to this endpoint
     * List locations using pagination  \'Permission#READ_LOCATION\' is required to access to this endpoint
     */
    LocationRestControllerApi.prototype.listLocationsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        if (requestParameters.network !== undefined) {
                            queryParameters['network'] = requestParameters.network;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.size !== undefined) {
                            queryParameters['size'] = requestParameters.size;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/locations",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return PagedResponseOfLocationListEntryFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * List locations using pagination  \'Permission#READ_LOCATION\' is required to access to this endpoint
     * List locations using pagination  \'Permission#READ_LOCATION\' is required to access to this endpoint
     */
    LocationRestControllerApi.prototype.listLocations = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listLocationsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Search locations using search request and pagination  \'Permission#READ_LOCATION\' is required to access to this endpoint
     * Search locations using search request and pagination  \'Permission#READ_LOCATION\' is required to access to this endpoint
     */
    LocationRestControllerApi.prototype.searchLocationsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.locationSearchRequest === null || requestParameters.locationSearchRequest === undefined) {
                            throw new runtime.RequiredError('locationSearchRequest', 'Required parameter requestParameters.locationSearchRequest was null or undefined when calling searchLocations.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.size !== undefined) {
                            queryParameters['size'] = requestParameters.size;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/locations/search",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: LocationSearchRequestToJSON(requestParameters.locationSearchRequest)
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return PagedResponseOfLocationListEntryFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Search locations using search request and pagination  \'Permission#READ_LOCATION\' is required to access to this endpoint
     * Search locations using search request and pagination  \'Permission#READ_LOCATION\' is required to access to this endpoint
     */
    LocationRestControllerApi.prototype.searchLocations = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.searchLocationsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update location  \'Permission#UPDATE_LOCATION\' is required to access to this endpoint
     * Update location  \'Permission#UPDATE_LOCATION\' is required to access to this endpoint
     */
    LocationRestControllerApi.prototype.updateLocationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
                            throw new runtime.RequiredError('locationId', 'Required parameter requestParameters.locationId was null or undefined when calling updateLocation.');
                        }
                        if (requestParameters.locationRequest === null || requestParameters.locationRequest === undefined) {
                            throw new runtime.RequiredError('locationRequest', 'Required parameter requestParameters.locationRequest was null or undefined when calling updateLocation.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/locations/{locationId}".replace("{".concat("locationId", "}"), encodeURIComponent(String(requestParameters.locationId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: LocationRequestToJSON(requestParameters.locationRequest)
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return LocationResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update location  \'Permission#UPDATE_LOCATION\' is required to access to this endpoint
     * Update location  \'Permission#UPDATE_LOCATION\' is required to access to this endpoint
     */
    LocationRestControllerApi.prototype.updateLocation = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateLocationRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return LocationRestControllerApi;
}(runtime.BaseAPI));
export { LocationRestControllerApi };
